import React, {Component} from 'react'
import { Row, Col, FormControl, Modal, Form, FormGroup, Button } from 'react-bootstrap'
import { Checkbox, Radio } from 'react-icheck'
import PrintPreview from './PrintPreview'
import FontAwsome from 'react-fontawesome'
import WorkdocStore from '../../stores/WorkdocStore'
import TextFieldModal from '../../component/element/TextFieldModal'

var NotificationSystem = require('react-notification-system');
const CHECK_LIST = [{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[]},{p:'',note:'',title:[{t:false},{t:false},{t:false}]},{p:'',note:'',title:[]},{p:'',note:'',title:[{t:false},{t:false},{t:false},{t:false}]},{p:'',note:'',title:[]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false},{t:false}]},{p:'',note:'',title:[{t:false}]},{p:'',note:'',title:[{t:false},{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false},{t:false},{t:false},{t:false},{t:false},{t:false}]},{p:'',note:'',title:[{t:false}]},{p:'',note:'',title:[{t:false},{t:false},{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[{t:false}]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[]},{p:'',note:'',title:[{t:false},{t:false},{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[{t:false}]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[{t:false}]},{p:'',note:'',title:[{t:false},{t:false}]},{p:'',note:'',title:[{t:false}]},{p:'',note:'',title:[{t:false}]}]
class PrintWorkQCDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,allList:{checkList:CHECK_LIST},page_title:'กำลังดึงข้อมูล..'}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadWorkdocRelated()
  }

  loadWorkdocRelated() {
    let {workNo} = this.props
    let {allList} = this.state
    WorkdocStore.loadWorkdocRelated(workNo,'work_qc_doc',(result)=>{
      if (result.data.length===0||result.data.allList===undefined||result.data.allList.checkList.length===0) {
        this.setState({allList:{checkList:CHECK_LIST},page_title:'ไม่พบข้อมูล'})
      } else {
        this.setState({allList:result.data.allList,page_title:'ไม่พบข้อมูล'})
      }  
    }) 
  }

  onNoteClick(key,value,e){
    let fieldInfo = {title:'หมายเหตุ',showClear:false,value:value,key:key}
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }
    
  onNoteSave(fieldInfo) {
    let {allList} = this.state
    let note = fieldInfo.value === undefined ? '' : fieldInfo.value
    allList.checkList[fieldInfo.key].note = note
    this.setState({allList:allList})
    this.saveDamagePartDoc()  
  }

  onTdCheckClick(key,value,e) { 
    let {allList} = this.state
    if (allList.checkList[key].p===value)
      value = ''
    else if (allList.checkList[key].p===''&&value===false)
      value = false
    else 
      value = value
    allList.checkList[key].p = value
    this.setState({allList:allList})
    this.saveDamagePartDoc()
  }
  
  onTitleChange(key,key1,value,e) {
    let {allList} = this.state
    allList.checkList[key].title[key1].t = value === true ? false : true
    this.setState({allList:allList})
    this.saveDamagePartDoc()
  }

  saveDamagePartDoc() {
    let {allList} = this.state
    let {workNo} = this.props
    let all_List = {allList:allList}
    WorkdocStore.saveWorkdocRelated(workNo,'work_qc_doc',all_List,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  renderRowTitle(text='',text1='',text2='',text3='') {
    return(
          <tr>
              <td style={{width:'500px'}}><h4 style={{margin:'0',color:'#111',fontWeight:'bold'}}>{text}</h4></td>
              <td style={{width:'50px'}} className='text-center'>{text1}</td>
              <td style={{width:'50px'}} className='text-center'>{text2}</td>
              <td style={{width:'200px'}} className='text-center'>{text3}</td>
            </tr>
    )
  }

  renderSec0() {
    let {allList} = this.state
    return([
      <tr key={0}>
        <td>1. สีรถ [รอยบุบ ลักยิ้ม มี ไม่มี ก้มดูสภาพใต้ท้องรถด้วย การดูสีรถแนะนำให้ดูในร่มนะครับ อย่าดูกลางแจ้งหรือที่มีแดด]</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,0,true)}>{allList.checkList[0].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,0,false)}>{allList.checkList[0].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,0,allList.checkList[0].note)}>{allList.checkList[0].note}</td>
      </tr>,
      <tr key={1}>
        <td>2. ยาง [ปียางที่ผลิต Max เก่า ใหม่ รอยวิ่งของยาง]</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,1,true)}>{allList.checkList[1].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,1,false)}>{allList.checkList[1].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,1,allList.checkList[1].note)}>{allList.checkList[1].note}</td>
      </tr>,
      <tr key={2}>
        <td>3. กระจก สภาพกระจกหน้า หลัง ประตู 4 บาน ...ร้าว..?? หน้า 2 ชั้น</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,2,true)}>{allList.checkList[2].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,2,false)}>{allList.checkList[2].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,2,allList.checkList[2].note)}>{allList.checkList[2].note}</td>
      </tr>,
      <tr key={3}>
        <td>4. ไฟ ไฟหน้า ไฟหลัง ไฟเบรก ไฟเลี้ยวข้างรถ</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,3,true)}>{allList.checkList[3].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,3,false)}>{allList.checkList[3].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,3,allList.checkList[3].note)}>{allList.checkList[3].note}</td>
      </tr>,
      <tr key={4}>
        <td>5. ประตู/กระโปรง ทดลองเปิด-ปิดประตูทั้ง 4 บาน ขัดตัวหรือไม่ ล็อคเด็กประตูหลัง</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,4,true)}>{allList.checkList[4].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,4,false)}>{allList.checkList[4].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,4,allList.checkList[4].note)}>{allList.checkList[4].note}</td>
      </tr>,
      <tr key={5}>
        <td>6. Seal  ยางขอบประตูทั้ง 4 เก่า ใหม่ [เหนียวหรือไม่]</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,5,true)}>{allList.checkList[5].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,5,false)}>{allList.checkList[5].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,5,allList.checkList[5].note)}>{allList.checkList[5].note}</td>
      </tr>,
      <tr key={6}>
        <td>
          7. 
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,6,0,allList.checkList[6].title[0].t)}
                checked={allList.checkList[6].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' แม่แรง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,6,1,allList.checkList[6].title[1].t)}
                checked={allList.checkList[6].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ล้ออะไหล่'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,6,2,allList.checkList[6].title[2].t)}
                checked={allList.checkList[6].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ประแจ'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,6,true)}>{allList.checkList[6].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,6,false)}>{allList.checkList[6].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,6,allList.checkList[6].note)}>{allList.checkList[6].note}</td>
      </tr>,
    ])
  }

  renderSec1() {
    let {allList} = this.state
    return([
      <tr key={0}>
        <td>8. เบาะ สภาพเบาะ แกะพลาสติก ดูว่าฉีกขาดหรือไม่ มีรอยเลอะหรือเปล่า</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,7,true)}>{allList.checkList[7].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,7,false)}>{allList.checkList[7].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,7,allList.checkList[7].note)}>{allList.checkList[7].note}</td>
      </tr>,
      <tr key={1}>
        <td>
          9. 
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,8,0,allList.checkList[8].title[0].t)}
                checked={allList.checkList[8].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ลายไม้'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,8,1,allList.checkList[8].title[1].t)}
                checked={allList.checkList[8].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' พนังหุ้มพวงมาลัย'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,8,2,allList.checkList[8].title[2].t)}
                checked={allList.checkList[8].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เกียร์'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,8,3,allList.checkList[8].title[3].t)}
                checked={allList.checkList[8].title[3].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ข้างประตู'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,8,true)}>{allList.checkList[8].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,8,false)}>{allList.checkList[8].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,8,allList.checkList[8].note)}>{allList.checkList[8].note}</td>
      </tr>,
      <tr key={2}>
        <td>10. หน้าปัทม์ ต้องไม่มีรอยขุด</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,9,true)}>{allList.checkList[9].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,9,false)}>{allList.checkList[9].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,9,allList.checkList[9].note)}>{allList.checkList[9].note}</td>
      </tr>,
      <tr key={3}>
        <td>
          11. ช่องเก็บของต่างๆ เปิดได้ 
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,10,0,allList.checkList[10].title[0].t)}
                checked={allList.checkList[10].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ม่านหลังรถ'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,10,1,allList.checkList[10].title[1].t)}
                checked={allList.checkList[10].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' พรม'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,10,true)}>{allList.checkList[10].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,10,false)}>{allList.checkList[10].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,10,allList.checkList[10].note)}>{allList.checkList[10].note}</td>
      </tr>,
      <tr key={4}>
        <td>
          12. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,11,0,allList.checkList[11].title[0].t)}
                checked={allList.checkList[11].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เข็มขัดนิรภัย 5 จุด ลองปรับ-กระตุกดู'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,11,1,allList.checkList[11].title[1].t)}
                checked={allList.checkList[11].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ที่เปิดกระโปรงหลัง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,11,2,allList.checkList[11].title[2].t)}
                checked={allList.checkList[11].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ฝาน้ำมัน'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,11,true)}>{allList.checkList[11].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,11,false)}>{allList.checkList[11].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,11,allList.checkList[11].note)}>{allList.checkList[11].note}</td>
      </tr>,
      <tr key={5}>
        <td>
          13. ปรับเบาะ ปรับเบาะคู่หน้าดู ดูทิศทาง
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,12,0,allList.checkList[12].title[0].t)}
                checked={allList.checkList[12].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เบาะรองศีรษะปรับดู'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,12,true)}>{allList.checkList[12].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,12,false)}>{allList.checkList[12].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,12,allList.checkList[12].note)}>{allList.checkList[12].note}</td>
      </tr>,
      <tr key={6}>
        <td>
          14. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,13,0,allList.checkList[13].title[0].t)}
                checked={allList.checkList[13].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ตรวจแป้นเบรค'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,13,1,allList.checkList[13].title[1].t)}
                checked={allList.checkList[13].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' คันเร่ง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,13,2,allList.checkList[13].title[2].t)}
                checked={allList.checkList[13].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เบรคมือ'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,13,true)}>{allList.checkList[13].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,13,false)}>{allList.checkList[13].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,13,allList.checkList[13].note)}>{allList.checkList[13].note}</td>
      </tr>,
    ])
  }  

  renderSec2() {
    let {allList} = this.state
    return([
      <tr key={0}>
        <td>
          15. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,14,0,allList.checkList[14].title[0].t)}
                checked={allList.checkList[14].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไฟหน้า'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,14,1,allList.checkList[14].title[1].t)}
                checked={allList.checkList[14].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไฟหรี่'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,14,2,allList.checkList[14].title[2].t)}
                checked={allList.checkList[14].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไฟขอทาง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,14,3,allList.checkList[14].title[3].t)}
                checked={allList.checkList[14].title[3].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไฟหน้าปัทม์'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,14,4,allList.checkList[14].title[4].t)}
                checked={allList.checkList[14].title[4].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไฟเก๋ง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,14,5,allList.checkList[14].title[5].t)}
                checked={allList.checkList[14].title[5].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไฟข้างประตู'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,14,6,allList.checkList[14].title[6].t)}
                checked={allList.checkList[14].title[6].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไฟเลี้ยว'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,14,true)}>{allList.checkList[14].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,14,false)}>{allList.checkList[14].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,14,allList.checkList[14].note)}>{allList.checkList[14].note}</td>
      </tr>,
      <tr key={1}>
        <td>
          16. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,15,0,allList.checkList[15].title[0].t)}
                checked={allList.checkList[15].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' แอร์ ทดสอบแอร์ ลองแรงลมทุกระดับ'}
              >
              </Checkbox>
              &nbsp;
              ที่วัดอุณหภูมิภายใน-นอก
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,15,true)}>{allList.checkList[15].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,15,false)}>{allList.checkList[15].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,15,allList.checkList[15].note)}>{allList.checkList[15].note}</td>
      </tr>,  
      <tr key={2}>
        <td>
          17. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,16,0,allList.checkList[16].title[0].t)}
                checked={allList.checkList[16].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' แตร'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,16,1,allList.checkList[16].title[1].t)}
                checked={allList.checkList[16].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ที่ปัดน้ำฝน INT'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,16,2,allList.checkList[16].title[2].t)}
                checked={allList.checkList[16].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' Senser ฝน'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,16,3,allList.checkList[16].title[3].t)}
                checked={allList.checkList[16].title[3].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไฟเบรคดวงที่ 3'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,16,true)}>{allList.checkList[16].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,16,false)}>{allList.checkList[16].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,16,allList.checkList[16].note)}>{allList.checkList[16].note}</td>
      </tr>,
      <tr key={3}>
        <td>
          18. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,17,0,allList.checkList[17].title[0].t)}
                checked={allList.checkList[17].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไล่ฝ้าหลัง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,17,1,allList.checkList[17].title[1].t)}
                checked={allList.checkList[17].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ไล่ฝ้าข้าง [ลองกดแล้วจับดูว่าร้อนไหม]'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,17,true)}>{allList.checkList[17].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,17,false)}>{allList.checkList[17].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,17,allList.checkList[17].note)}>{allList.checkList[17].note}</td>
      </tr>,
      <tr key={4}>
        <td>
          19. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,18,0,allList.checkList[18].title[0].t)}
                checked={allList.checkList[18].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' หมุนพวงมาลัยดูจนสุด 2 ด้านมีเสียงดัง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,18,1,allList.checkList[18].title[1].t)}
                checked={allList.checkList[18].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ปรับไกล-ใกล้ สูง-ต่ำ'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,18,true)}>{allList.checkList[18].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,18,false)}>{allList.checkList[18].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,18,allList.checkList[18].note)}>{allList.checkList[18].note}</td>
      </tr>,
      <tr key={5}>
        <td>
          20. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,19,0,allList.checkList[19].title[0].t)}
                checked={allList.checkList[19].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' วิทยุ CD ลองฟังแยกทุกจุดว่า OK'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,19,true)}>{allList.checkList[19].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,19,false)}>{allList.checkList[19].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,19,allList.checkList[19].note)}>{allList.checkList[19].note}</td>
      </tr>,
      <tr key={6}>
        <td>
          21. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,20,0,allList.checkList[20].title[0].t)}
                checked={allList.checkList[20].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' กระจกไฟฟ้า 4 บาน'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,20,1,allList.checkList[20].title[1].t)}
                checked={allList.checkList[20].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' กระจกข้าง [ปรับได้ ลองพับ ป้องกันหนีบ]'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,20,true)}>{allList.checkList[20].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,20,false)}>{allList.checkList[20].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,20,allList.checkList[20].note)}>{allList.checkList[20].note}</td>
      </tr>,
      <tr key={7}>
        <td>
          22. สัญญานเตือนไฟเปิด
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,21,0,allList.checkList[21].title[0].t)}
                checked={allList.checkList[21].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ประตูเปิดขาดเข็มขัด'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,21,1,allList.checkList[21].title[1].t)}
                checked={allList.checkList[21].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เบรคมือ'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,21,2,allList.checkList[21].title[2].t)}
                checked={allList.checkList[21].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' นาฬิกา'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,21,true)}>{allList.checkList[21].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,21,false)}>{allList.checkList[21].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,21,allList.checkList[21].note)}>{allList.checkList[21].note}</td>
      </tr>,
      <tr key={8}>
        <td>
          23. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,22,0,allList.checkList[22].title[0].t)}
                checked={allList.checkList[22].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' กุญแจรีโมท'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,22,1,allList.checkList[22].title[1].t)}
                checked={allList.checkList[22].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' Central Lock'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,22,true)}>{allList.checkList[22].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,22,false)}>{allList.checkList[22].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,22,allList.checkList[22].note)}>{allList.checkList[22].note}</td>
      </tr>,
      <tr key={9}>
        <td>
          24. ไฟแสดงตำแหน่งเกียร์
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,23,true)}>{allList.checkList[23].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,23,false)}>{allList.checkList[23].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,23,allList.checkList[23].note)}>{allList.checkList[23].note}</td>
      </tr>,
    ])
  }  

  renderSec3() {
    let {allList} = this.state
    return([
      <tr key={0}>
        <td>
          25. ตรวจใต้ฝากระโปรง
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,24,0,allList.checkList[24].title[0].t)}
                checked={allList.checkList[24].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' หน้า'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,24,1,allList.checkList[24].title[1].t)}
                checked={allList.checkList[24].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' หลัง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,24,2,allList.checkList[24].title[2].t)}
                checked={allList.checkList[24].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' สภาพห้องเครื่อง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,24,3,allList.checkList[24].title[3].t)}
                checked={allList.checkList[24].title[3].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ใต้ห้องเครื่อง'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,24,true)}>{allList.checkList[24].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,24,false)}>{allList.checkList[24].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,24,allList.checkList[24].note)}>{allList.checkList[24].note}</td>
      </tr>,
      <tr key={1}>
        <td>
          26. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,25,0,allList.checkList[25].title[0].t)}
                checked={allList.checkList[25].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' น้ำมันเบรค'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,25,1,allList.checkList[25].title[1].t)}
                checked={allList.checkList[25].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' น้ำมันเครื่อง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,25,2,allList.checkList[25].title[2].t)}
                checked={allList.checkList[25].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' น้ำมันเกียร์ [ถามให้รู้ว่าอยู่ตรงไหน]'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,25,true)}>{allList.checkList[25].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,25,false)}>{allList.checkList[25].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,25,allList.checkList[25].note)}>{allList.checkList[25].note}</td>
      </tr>,
      <tr key={2}>
        <td>
          27. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,26,0,allList.checkList[26].title[0].t)}
                checked={allList.checkList[26].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' สายพานต่างๆ'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,26,1,allList.checkList[26].title[1].t)}
                checked={allList.checkList[26].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' น้ำหม้อน้ำ'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,26,2,allList.checkList[26].title[2].t)}
                checked={allList.checkList[26].title[2].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ระดับน้ำฉีดกระจก'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,26,true)}>{allList.checkList[26].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,26,false)}>{allList.checkList[26].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,26,allList.checkList[26].note)}>{allList.checkList[26].note}</td>
      </tr>,
      <tr key={3}>
        <td>
          28. &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,27,0,allList.checkList[27].title[0].t)}
                checked={allList.checkList[27].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ลอง Start เครื่องฟังเสียงดู'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,27,1,allList.checkList[27].title[1].t)}
                checked={allList.checkList[27].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เร่งเครื่องฟังเสียงในห้องโดยสาร'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,27,true)}>{allList.checkList[27].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,27,false)}>{allList.checkList[27].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,27,allList.checkList[27].note)}>{allList.checkList[27].note}</td>
      </tr>,
    ])
  }

  renderSec4() {
    let {allList} = this.state
    return([
      <tr key={0}>
        <td>
              <Checkbox
                onChange={this.onTitleChange.bind(this,28,0,allList.checkList[28].title[0].t)}
                checked={allList.checkList[28].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เอกสารรับประกัน'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,28,1,allList.checkList[28].title[1].t)}
                checked={allList.checkList[28].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' พรบ.'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,28,true)}>{allList.checkList[28].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,28,false)}>{allList.checkList[28].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,28,allList.checkList[28].note)}>{allList.checkList[28].note}</td>
      </tr>,
      <tr key={1}>
        <td>
              <Checkbox
                onChange={this.onTitleChange.bind(this,29,0,allList.checkList[29].title[0].t)}
                checked={allList.checkList[29].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ใบเสร็จรับเงิน'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,29,true)}>{allList.checkList[29].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,29,false)}>{allList.checkList[29].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,29,allList.checkList[29].note)}>{allList.checkList[29].note}</td>
      </tr>,
      <tr key={2}>
        <td>
              <Checkbox
                onChange={this.onTitleChange.bind(this,30,0,allList.checkList[30].title[0].t)}
                checked={allList.checkList[30].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ใบเสร็จค่ามัดจำป้ายแดง'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,30,1,allList.checkList[30].title[1].t)}
                checked={allList.checkList[30].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' สมุดคู่มือป้ายแดง'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,30,true)}>{allList.checkList[30].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,30,false)}>{allList.checkList[30].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,30,allList.checkList[30].note)}>{allList.checkList[30].note}</td>
      </tr>,
      <tr key={3}>
        <td>
              <Checkbox
                onChange={this.onTitleChange.bind(this,31,0,allList.checkList[31].title[0].t)}
                checked={allList.checkList[31].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ป้ายแดงมีตรา ขส'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,31,true)}>{allList.checkList[31].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,31,false)}>{allList.checkList[31].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,31,allList.checkList[31].note)}>{allList.checkList[31].note}</td>
      </tr>,
      <tr key={4}>
        <td>
              <Checkbox
                onChange={this.onTitleChange.bind(this,32,0,allList.checkList[32].title[0].t)}
                checked={allList.checkList[32].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เอกสารรับประกันอุปกรณ์รถ และเช็คระยะฟรี'}
              >
              </Checkbox>
              &nbsp;
              <Checkbox
                onChange={this.onTitleChange.bind(this,32,1,allList.checkList[32].title[1].t)}
                checked={allList.checkList[32].title[1].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' คู่มือรถ'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,32,true)}>{allList.checkList[32].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,32,false)}>{allList.checkList[32].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,32,allList.checkList[32].note)}>{allList.checkList[32].note}</td>
      </tr>,   
      <tr key={5}>
        <td>
              <Checkbox
                onChange={this.onTitleChange.bind(this,33,0,allList.checkList[33].title[0].t)}
                checked={allList.checkList[33].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' เอกสารเซ็นต์เตรียมจดทะเทียน'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,33,true)}>{allList.checkList[33].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,33,false)}>{allList.checkList[33].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,33,allList.checkList[33].note)}>{allList.checkList[33].note}</td>
      </tr>,
      <tr key={6}>
        <td>
              <Checkbox
                onChange={this.onTitleChange.bind(this,34,0,allList.checkList[34].title[0].t)}
                checked={allList.checkList[34].title[0].t}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ของแถมต่างๆ ตามตกลงในใบจอง'}
              >
              </Checkbox>
        </td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,34,true)}>{allList.checkList[34].p===true ? <FontAwsome name='check' /> : ''}</td>
        <td className='text-center' onClick={this.onTdCheckClick.bind(this,34,false)}>{allList.checkList[34].p===false ? <FontAwsome name='check' /> : ''}</td>
        <td onClick={this.onNoteClick.bind(this,34,allList.checkList[34].note)}>{allList.checkList[34].note}</td>
      </tr>,     
    ])
  }

  renderComponentPage() {
    return(
      <div className='font-print font-14'>
        <table className='table table-print-work-qc-doc'>
          <tbody>
            <tr>
              <td colSpan={4} className='row-title text-center'>{this.props.title}</td>
            </tr>
            {this.renderRowTitle('ภายนอก','ผ่าน','ไม่ผ่าน','หมายเหตุ')}
            {this.renderSec0()}
            {this.renderRowTitle('ภายใน')}
            {this.renderSec1()}
            {this.renderRowTitle('ระบบไฟฟ้า')}
            {this.renderSec2()}
            {this.renderRowTitle('ห้องเครื่อง')}
            {this.renderSec3()}
            {this.renderRowTitle('เอกสาร')}
            {this.renderSec4()}
          </tbody>
        </table> 
        <div className='footer-page' style={{width:'95%'}}>
          <div>
            <table className='table table-print-work-qc-doc-2'>
              <tbody>
                <tr>
                  <td className='text-center' style={{width:'33.33%'}}>
                    <div>ลงชื่อ..................................................ผู้ตรวจสอบความเสียหาย</div>
                    <div>นาย ธนโชติ อินทร์จอหอ</div>
                    <div>หัวหน้าช่าง</div>
                  </td>
                  <td className='text-center' style={{width:'33.33%'}}>
                    <div>ลงชื่อ..................................................ผู้รับทราบ</div>
                    <div>นาง สุวรรณภา ทาสันเทียะ</div>
                    <div>เจ้าหน้าที่จัดซื้อ</div>
                    <div></div>
                  </td>
                  <td className='text-center' style={{width:'33.33%'}}>
                    <div>ลงชื่อ..................................................ผู้อนุมัติส่งมอบรถ</div>
                    <div>นาย สมเดช เรดสันเทียะ</div>
                    <div>ผจก.เคเคซี เกษมการช่าง</div>
                    <div></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>   
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <div>
        <PrintPreview 
            loading={loading}
            leftBarTitle={this.props.title}
            sliptable={'sliptable-page-padding02-desktop'}
          >
            {this.renderComponentPage()}
        </PrintPreview>
        <TextFieldModal 
          ref='textFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onNoteSave.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintWorkQCDoc.defaultProps = {
  title: 'ขั้นตอนการตรวจรับรถก่อนส่งมอบลูกค้า',  
  mode : '1'
}
export default PrintWorkQCDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintWorkQCDoc.js